'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSettingsStrong = function IoIosSettingsStrong(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm0 29.4h22.1c0.5-1.1 1.7-1.9 2.9-1.9s2.4 0.8 2.9 1.9h7.1v2.5h-7.1c-0.5 1.1-1.6 1.9-2.9 1.9s-2.4-0.8-2.9-1.9h-22.1z m0-10.6h7.1c0.5-1.1 1.7-1.9 2.9-1.9s2.4 0.8 2.9 1.9h22.1v2.5h-22.1c-0.5 1-1.6 1.8-2.9 1.8s-2.4-0.8-2.9-1.8h-7.1z m0-10.7h22.1c0.5-1.1 1.7-1.8 2.9-1.8s2.4 0.7 2.9 1.8h7.1v2.5h-7.1c-0.5 1.1-1.6 1.9-2.9 1.9s-2.4-0.8-2.9-1.9h-22.1z' })
        )
    );
};

exports.default = IoIosSettingsStrong;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-settings-strong.js
// module id = 2278
// module chunks = 0